module.exports = __webpack_public_path__ + "static/media/particles2.39ee0690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/particles2.svg
// module id = 167
// module chunks = 0